import React from "react";
import axios from "axios";

import _ from "lodash";
import jwtDecode from "jwt-decode";

import {
  ShowNotification,
  getAppEnv,
  keyLocallyPresentInStorage,
  setCookie,
  logout,
} from "./Helpers";
import { refreshToken } from "./Services";

/**
 * @function InterceptorService
 * @param props
 * @desc The request interceptor blocks invalid outgoing requests to avoid 403 or 401 errors
 * The response interceptor catches the errors and shows it on UI in the form of notifications
 */

const InterceptorService = () => {
  /**
   * @function isJwtExpired
   * @desc This function checks if the auth token is valid ot is expired
   */
  function isJwtExpired() {
    const authToken = keyLocallyPresentInStorage("authToken")
      ? localStorage.getItem("authToken")
      : null;

    if (typeof authToken !== "string" || !authToken) {
      ShowNotification("Invalid token provided");
      return false;
    }

    let isJwtExpired = false;
    const { exp } = jwtDecode(authToken);
    const currentTime = new Date().getTime() / 1000;
    if (currentTime > exp) isJwtExpired = true;

    if (isJwtExpired) handleRefreshToken();
  }

  /**
   * @function handleRefreshToken
   * @desc This function handles refreshing token
   */
  function handleRefreshToken() {
    const params = {
      refresh_token: localStorage.getItem("idt"),
    };

    refreshToken(params).then((response) => {
      if (response?.data?.success) {
        const responseObj = response.data;
        localStorage.setItem("authToken", `Bearer ${responseObj.auth_token}`);
        localStorage.setItem("idt", responseObj.refresh_token);
        setCookie(
          `${getAppEnv()}_authToken`,
          `Bearer ${responseObj.auth_token}`
        );
        setCookie(`${getAppEnv()}_id_tkn`, `${responseObj.refresh_token}`);
        // showErrorNotification(
        //   "Your session is expired, please try again to continue"
        // );
      } else {
        logout();
      }
    });
  }

  // Response interceptor
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (errorMsg) {
      if (
        // Logout on 401 and 403 errors
        (errorMsg.response && errorMsg.response.status === 401) ||
        (errorMsg.response && errorMsg.response.status === 403)
      ) {
        if (
          keyLocallyPresentInStorage("idt") &&
          errorMsg.response &&
          errorMsg.response.status === 401
        ) {
          isJwtExpired();
        }
        // hit refresh token api here
      } else {
        return Promise.reject(errorMsg);
      }
    }
  );
};
export { InterceptorService };
